import * as React from 'react';
import { useSelector } from 'react-redux';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { trackBannerClick, trackBannerShow } from './tracking';
import { Banner } from '../../components/Banner';

import { selectPage } from '../../selectors/analytics';
import { selectBanner } from '../../selectors/promosPage';
import { IBanner } from '../../types/promosPage/banner';
import { BannerPopupContainer } from '../BannerPopupContainer';

export const BannerContainer = () => {
  const [isPopupOpen, setPopupOpen] = React.useState(false);

  const banner = useSelector(selectBanner);
  const page = useSelector(selectPage);

  const openPopup = React.useCallback(() => {
    setPopupOpen(true);
    trackBannerClick({ label: (banner as IBanner).analyticsLabel, page });
  }, [banner, page]);

  const handleShowBanner = React.useCallback(() => {
    trackBannerShow({ label: (banner as IBanner).analyticsLabel, page });
  }, [banner, page]);

  const closePopup = React.useCallback(() => {
    setPopupOpen(false);
  }, []);

  if (!banner) {
    return null;
  }

  return (
    <>
      <ActionAfterViewObserver callback={handleShowBanner} percentVisible={0.8} triggerOnce>
        <Banner
          backgroundColor={banner.backgroundColor}
          backgroundImage={banner.logoImage}
          color={banner.fontColor}
          title={banner.title}
          onClick={openPopup}
        />
      </ActionAfterViewObserver>
      <BannerPopupContainer open={isPopupOpen} onClose={closePopup} />
    </>
  );
};
